/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from 'react';
import { closelightbox } from '../../util/Functions';
import { useForm } from "react-hook-form";
import * as API from '../../http/api';
import { useHistory } from 'react-router-dom';

const AssignAfb = (props) => {
    const { handleSubmit, register, errors } = useForm();
    const history = useHistory();

    useEffect(() => {

    }, []);

    const onSubmit = (values) => {
        send(values);
    }

    const send = async (values) => {

        props.changeLoader(true);

        let request = await API.service('assignAfb', values, props.pos, props.changeAlert, props.changeLoader, history);

        if (request.status === 200 && request.data.data.response === 'OK') {
            for (let i = 0; i < request.data.data.widget.length; i++) {
                let widget = request.data.data.widget[i];
                if (widget.type === 'roles') {
                    props.updateNext('update');
                    props.item.data = widget.data;
                }
            }
        }
        props.changeLoader(false);
    }

    return (
        <div className="card">
            <div className="text-right modal_header_close">
                <i className="ibon-close tap" onClick={closelightbox}></i>
            </div>
            <h3 className='modal_header_title'>{props.title}</h3>
            <form className='row fx-form-cnt' onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                <div className="size-12">
                    <div className="inputGroup">
                        <input name="rfc" ref={register()} type="text" placeholder="RFC empresa" />
                        <div className="inputLabel"><label >RFC Empresa</label></div>
                    </div>
                    <div className="inputGroup">
                        <input name="customer" ref={register()} type="text" placeholder="Email cliente" />
                        <div className="inputLabel"><label >Email cliente</label></div>
                    </div>
                </div>
                <div className="size-12 ">
                    <div className="bigButton pos-right pnl-btn-save">
                        <button type="submit">Guardar</button>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default AssignAfb;

